<template>
  <div class="main supervision-main">
    <el-card>
      <search-bar
        :search-params="searchParams"
        :store-id="storeId"
        @changeSearchParams="changeSearchParams"
        @search="search"
      />
      <registration-list :data="list" />
      <pagination
        @handlePage="handlePage"
        v-if="list && list.length"
        :total="total"
        :current-page="pageNo"
        :page-size="pageSize"
      />
    </el-card>
  </div>
</template>

<script>
import Fetch from '@/api';
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import searchBar from './components/searchBar';
import registrationList from './components/pharmacistList';
import pagination from './components/pagination';

export default {
  name: 'orderList',
  components: {
    searchBar,
    registrationList,
    pagination
  },
  data() {
    return {
      searchParams: {
        pharmacistName: '',
        practiceCertNo: '',
        practiceCertStatus: null,
        userStatus: 1,
        auditStatus: null,
        practiceCategory: null,
        dateRange: []
      },
      list: [],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      tabs: 'today',
      statics: {}
    };
  },
  computed: {
    ...mapGetters(['storeList']),
    storeId() {
      // 多店业务上暂时不考虑
      const { storeList } = this;
      return Array.isArray(storeList) ? storeList?.[0].id : storeList?.id;
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const { pageSize } = this;
      const { dateRange } = this.searchParams;
      const [practiceCertTimeStart, practiceCertTimeEnd] = dateRange || [];
      this.fetchList({ practiceCertTimeStart, practiceCertTimeEnd, pageNo: 1, pageSize });
    },
    handlePage(pageNo) {
      const { searchParams, pageSize } = this;
      const { dateRange, ...rest } = searchParams;
      const [practiceCertTimeStart, practiceCertTimeEnd] = dateRange || [];
      this.fetchList({ ...rest, practiceCertTimeStart, practiceCertTimeEnd, pageNo, pageSize });
    },
    search() {
      const { searchParams, pageSize } = this;
      console.log(searchParams);
      const { dateRange, ...rest } = searchParams;
      const [practiceCertTimeStart, practiceCertTimeEnd] = dateRange || [];
      this.fetchList({ ...rest, practiceCertTimeStart, practiceCertTimeEnd, pageNo: 1, pageSize });
    },
    changeSearchParams({ key, value }) {
      this.searchParams[key] = value;
    },
    fetchList(params) {
      const { storeId } = this;
      const { pharmacistName, practiceCertNo, ...rest } = params;
      return Fetch.getPharmacistIvList({
        ...rest,
        pharmacistName: pharmacistName || null,
        practiceCertNo: practiceCertNo || null,
        storeId
      }).then(res => {
        const { pageNo, totalCount, data } = res;
        this.pageNo = pageNo;
        this.total = totalCount;
        this.list = data;
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
